import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import EstadoEstudiosForm from '../EstadoEstudiosForm';

function EstadoEstudiosEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <EstadoEstudiosForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </EstadoEstudiosForm>
    </Edit>
  );
}

export default EstadoEstudiosEdit;
